<p class="ion-text-center instructions-title">Indica el tipo de juego</p>
<ion-radio-group [value]="value">
  <ion-grid fixed class="ion-no-padding">
    <ion-row class="ion-no-padding">
      <ion-col [size]="12 / sizes.length" *ngFor="let item of sizes" class="ion-text-center">
        <ion-radio mode="md" color="primary" labelPlacement="end" (click)="changeSize.emit(item)" [value]="item">
          <span>
            {{ item }}
          </span>
        </ion-radio>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-radio-group>
